import React, { useEffect, useState } from 'react';
import { Clock, AlertTriangle } from 'lucide-react';
interface CountdownChipProps {
  targetDate: string;
  urgency: 'healthy' | 'warning' | 'critical';
}
export function CountdownChip({
  targetDate,
  urgency
}: CountdownChipProps) {
  const [timeLeft, setTimeLeft] = useState('');
  useEffect(() => {
    const calculateTimeLeft = () => {
      const target = new Date(targetDate).getTime();
      const now = new Date().getTime();
      const difference = target - now;
      if (difference <= 0) {
        return '00:00:00';
      }
      const hours = Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(difference % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(difference % (1000 * 60) / 1000);
      return `${hours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`;
    };
    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, [targetDate]);
  const config = {
    healthy: {
      bg: 'bg-slate-100',
      text: 'text-slate-700',
      icon: Clock,
      animate: false
    },
    warning: {
      bg: 'bg-amber-100',
      text: 'text-amber-800',
      icon: Clock,
      animate: false
    },
    critical: {
      bg: 'bg-red-100',
      text: 'text-red-800',
      icon: AlertTriangle,
      animate: true
    }
  };
  const {
    bg,
    text,
    icon: Icon,
    animate
  } = config[urgency];
  return <div className={`flex items-center gap-1.5 px-2 py-1 rounded-md ${bg} ${text} text-xs font-semibold font-mono tracking-tight`} data-id="element-74">
      <Icon className={`w-3.5 h-3.5 ${animate ? 'animate-pulse' : ''}`} data-id="element-75" />
      {timeLeft}
    </div>;
}